module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zkqq"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("./推广-头部.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "go-to-open",
    on: {
      "click": _vm.openApp
    }
  }), _vm._v(" "), _c('div', {
    ref: "zkqq"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-tip bg-gray"
  }, [_c('div', {
    staticClass: "risk-warn-text"
  }, [_vm._v("风险提示：任何软件都可能发生无法控制或不可预测的故障，为了确保交易不受影响，请务必安装多个软件以备紧急情况下使用！")]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("./东航快期小Q.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mt-16"
  }, [_c('a', {
    attrs: {
      "href": "https://apps.apple.com/cn/app/%E5%BF%AB%E6%9C%9F%E5%B0%8Fq/id1187762307"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("IOS下载")])])]), _vm._v(" "), _c('p', {
    staticClass: "mt-12"
  }, [_c('a', {
    attrs: {
      "href": "https://www.shinnytech.com/ces"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("安卓下载")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("东航快期小Q")]), _vm._v(" "), _c('div', {
    staticClass: "text letter-spacing"
  }, [_c('p', [_vm._v("\n              以极简界面风格为客户提供流畅的期货和期权交易体验，除实现银期转账/资金查询/行情分析/下单撤单外，还支持交易所标准组合套利交易，内嵌上海期货交易所/能源交易所五档深度行情。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-tip"
  }, [_c('div', {
    staticClass: "flex-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("东航易星Estar")]), _vm._v(" "), _c('div', {
    staticClass: "text letter-spacing"
  }, [_c('p', [_vm._v("\n              为客户提供全方位的期货行情/期货&期权交易/期权策略/多账户交易/云条件单/画线下单/止损止盈单服务,内嵌郑商所/上海黄金交易所。")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("./东航易星Estar.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mt-16"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/estar易星/id1269479413?l=en&mt=8"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("IOS下载")])])]), _vm._v(" "), _c('p', {
    staticClass: "mt-12"
  }, [_c('a', {
    attrs: {
      "href": "https://fpub.kiiik.com/qhweb/xzzx/file/EstarAndroid.apk"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("安卓下载")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-tip bg-gray"
  }, [_c('div', {
    staticClass: "flex-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("./东航金融二维码logo标准版.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mt-16"
  }, [_c('a', {
    attrs: {
      "href": "http://m.kiiik.com/kiiikweixin/iphoned.jsp?cesfid=kiiik"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("IOS下载")])])]), _vm._v(" "), _c('p', {
    staticClass: "mt-12"
  }, [_c('a', {
    attrs: {
      "href": "https://m.cesfutures.com/kiiikweixin/appproNew/download.html"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("安卓下载")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("东航金融APP")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("服务：开户、咨询、智能数据、交易策略、投资工具、蓝海密剑。")]), _vm._v(" "), _c('p', [_vm._v("行情：提供国内五大期货交易所及境外十余家期货交易所正版行情。")]), _vm._v(" "), _c('p', [_vm._v("交易：支持期货、期权交易。提供云条件单/画线下单/止损止盈单等服务。")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4347ea4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zkqq/index.vue
// module id = 908
// module chunks = 2